// "use client";

// import {
//   ArrowRight,
//   Calendar,
//   Clock,
//   IdentificationBadge,
// } from "@phosphor-icons/react";
// import { useEffect, useState } from "react";

// const BatchCards = ({ courses }) => {
//   const [activeCardId, setActiveCardId] = useState(null);

//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkIsMobile = () => {
//       setIsMobile(window.innerWidth < 1024);
//     };

//     checkIsMobile();
//     window.addEventListener("resize", checkIsMobile);

//     return () => window.removeEventListener("resize", checkIsMobile);
//   }, []);

//   const handleCardClick = (id) => {
//     if (!isMobile) return;
//     setActiveCardId((prev) => (prev === id ? null : id));
//   };

  // const cardArr = [
  //   {
  //     id: 1,
  //     title: "CFA Prep Course",
  //     price: "₹ 20,000/_",
  //     discountedPrice: "₹ 18,000/_",
  //     description:
  //       "Master the CFA curriculum and accelerate your finance career. This course is designed to help you build a strong foundation in financial modeling and analysis.",
  //     batchStartDate: "May 2025",
  //     batchTime: "12:00 - 1:00 p.m.",
  //     batchDays: "Weekend Batch (Sat & Sun)",
  //     ctaButton: "Enroll Now",
  //   },
  //   {
  //     id: 2,
  //     title: "Quantitative Finance",
  //     price: "₹ 20,000/_",
  //     discountedPrice: "₹ 18,000/_",
  //     description:
  //       "Master the CFA curriculum and accelerate your finance career. This course is designed to help you build a strong foundation in financial modeling and analysis.",
  //     batchStartDate: "May 2025",
  //     batchTime: "12:00 - 1:00 p.m.",
  //     batchDays: "Weekend Batch (Sat & Sun)",
  //     ctaButton: "Enroll Now",
  //   },
  //   {
  //     id: 3,
  //     title: "Python Modelling",
  //     price: "₹ 20,000/_",
  //     discountedPrice: "₹ 18,000/_",
  //     description:
  //       "Master the CFA curriculum and accelerate your finance career. This course is designed to help you build a strong foundation in financial modeling and analysis.",
  //     batchStartDate: "May 2025",
  //     batchTime: "12:00 - 1:00 p.m.",
  //     batchDays: "Weekend Batch (Sat & Sun)",
  //     ctaButton: "Enroll Now",
  //   },
  // ];

//   return (
//     <div className="flex flex-col lg:flex-row gap-[32px] lg:gap-[24px] justify-end">
//       {courses.map((card, index) => {
//         const isActive = activeCardId === index;

//         return (
//           <div
//             key={index}
//             onClick={() => handleCardClick(index)}
//             className={`
//               group w-[358px] lg:w-[156px] 
//               ${isActive ? "h-[463px]" : "h-[134px]"} lg:h-[439px]
//               rounded-[12px] border border-[#EFEFEF] 
//               flex flex-row-reverse lg:flex-col justify-between items-center 
//               p-[32px] overflow-visible 
//               transform origin-right 
//               transition-all duration-700 
//               ${isActive ? "bg-[#08448F]" : "bg-white"}
//               lg:hover:w-[350px] lg:hover:bg-[#08448F] 
//               cursor-pointer relative
//             `}
//           >
//             <div className="flex items-center h-[200px] w-[193px] lg:w-auto transition-all duration-300">
//               <p
//                 className={`
//                   text-[28px] lg:text-[27px] font-[600] rotate-[0deg] lg:rotate-[-90deg] leading-[110%] w-[300px]
//                   transition-all duration-300 
//                   ${isActive ? "opacity-0 scale-0" : "opacity-100 scale-100"} 
//                   group-hover:opacity-0 group-hover:scale-0
//                 `}
//               >
//                 {card?.title}
//               </p>
//             </div>

//             <div
//               className={`
//                 transition-all duration-300 
//                 ${isActive ? "opacity-0 scale-0" : "opacity-100 scale-100"} 
//                 group-hover:opacity-0 group-hover:scale-0
//               `}
//             >
//               <p className="text-[60px] lg:text-[80px] font-[600] text-primary">
//                 {String(index + 1).padStart(2, "0")}
//               </p>
//             </div>

//             <div
//               className={`
//                 absolute top-0 left-0 w-full h-full flex flex-col items-start py-[32px] px-[24px]
//                 transition-all duration-500 text-white
//                 ${
//                   isActive
//                     ? "opacity-100 scale-100 translate-x-0"
//                     : "opacity-0 scale-0 translate-x-4"
//                 } 
//                 group-hover:opacity-100 group-hover:scale-100 group-hover:translate-x-0 transition-all duration-800 delay-100
//               `}
//             >
//               {card?.few_seats_left && (
//                 <div
//                   className="absolute -top-[19px] left-[227px] bg-[#FFC027] text-black text-[12px] font-[600] px-[8px] py-[12px] rounded-[20px] shadow-md z-10 
//                         opacity-100 lg:opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-700 delay-500"
//                 >
//                   Few Seats Left
//                 </div>
//               )}
//               <div
//                 className={`flex flex-col gap-[32px] overflow-hidden
//               transition-all duration-500 delay-300 group-hover:opacity-100 group-hover:scale-100 group-hover:translate-x-0
//                   ${
//                     isActive
//                       ? "opacity-100 scale-100 translate-x-0"
//                       : "opacity-0 scale-0 translate-x-4"
//                   }
//               `}
//               >
//                 <div className="flex flex-col gap-[16px]">
//                   <div className="flex flex-col gap-[16px] lg:gap-[12px]">
//                     <h3
//                       className="text-[24px] font-[600] leading-[110%]
//                     transition-all duration-700 delay-500"
//                     >
//                       {card?.title}
//                     </h3>
//                     <div className="flex gap-[12px] items-center">
//                       <p
//                         className="line-through text-[#A0A0A0] font-[600]
//                  "
//                       >
//                         ₹ {Number(card?.price).toLocaleString("en-IN")}/_
//                       </p>
//                       {card?.is_discounted && (
//                         <p className="text-[21px] text-[#FF9A27] font-[600]">
//                          ₹ {Number(card?.discount_price).toLocaleString("en-IN")} /_
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                   <p className="text-[16px] font-[400] text-[#E4E4E4] leading-[100%] ">
//                     {card?.short_description}
//                   </p>
//                 </div>
//                 <div className="flex flex-col gap-[12px]">
//                   <div className="flex gap-[12px] items-center">
//                     <IdentificationBadge size={24} />
//                     <p className="font-[400] text-[21px] text-[#E4E4E4]">
//                       Upcoming Batch:{" "}
//                       <span className="text-[21px] font-[600]">
//                         {new Date(card?.starting_date).toLocaleDateString(
//                           "en-GB",
//                           { day: "2-digit", month: "short" }
//                         )}
//                       </span>
//                     </p>
//                   </div>
//                   <div className="flex gap-[12px] items-center">
//                     <Clock size={24} />
//                     <p className="font-[400] text-[16px] text-[#E4E4E4]">
//                       Schedule: <span>{card?.batch_time}</span>
//                     </p>
//                   </div>
//                   <div className="flex gap-[12px] items-center">
//                     <Calendar size={24} />
//                     <p className="font-[400] text-[16px] text-[#E4E4E4]">
//                       {card?.batch_type} Batch{" "}
//                       {card?.batch_days?.length > 0 && (
//                         <span>({card.batch_days.join(" & ")})</span>
//                       )}
//                     </p>
//                   </div>
//                   <button className="px-[16px] py-[8px] bg-white text-[#0D6FEA] font-[400] rounded hover:bg-gray-200 transition-all duration-300 delay-700 uppercase flex gap-[8px] items-center justify-center">
//                     Enroll Now <ArrowRight size={24} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default BatchCards;

"use client";

import {
  ArrowRight,
  Calendar,
  Clock,
  IdentificationBadge,
} from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";
import Link from "next/link";

const getFullSignupPath = (course) => {
  const id = course?.id || course?._id || course?.course_id || course?.slug;
  return id ? `/register/full?course_id=${id}` : "/register/full";
};

const BatchCards = ({ courses }) => {
  const [activeCardId, setActiveCardId] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const handleCardClick = (id) => {
    if (!isMobile) return;
    setActiveCardId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="flex flex-col lg:flex-row gap-[32px] lg:gap-[24px] justify-end">
      {courses.map((card, index) => {
        const isActive = activeCardId === index;

        return (
          <div
            key={index}
            onClick={() => handleCardClick(index)}
            className={`
              group w-[358px] lg:w-[156px] 
              ${isActive ? "h-[463px]" : "h-[134px]"} lg:h-[439px]
              rounded-[12px] border border-[#EFEFEF] 
              flex flex-row-reverse lg:flex-col justify-between items-center 
              p-[32px] overflow-visible 
              transform origin-right 
              transition-all duration-700 
              ${isActive ? "bg-[#08448F]" : "bg-white"}
              lg:hover:w-[350px] lg:hover:bg-[#08448F] 
              cursor-pointer relative
            `}
          >
            <div className="flex items-center h-[200px] w-[193px] lg:w-auto transition-all duration-300">
              <p
                className={`
                  text-[28px] lg:text-[27px] font-[600] rotate-[0deg] lg:rotate-[-90deg] leading-[110%] w-[300px]
                  transition-all duration-300 
                  ${
                    isActive
                      ? "opacity-0 translate-x-4"
                      : "opacity-100 translate-x-0"
                  } 
                  group-hover:opacity-0 group-hover:translate-x-4
                `}
              >
                {card?.title}
              </p>
            </div>

            <div
              className={`
                transition-all duration-300 
                ${
                  isActive
                    ? "opacity-0 translate-x-4"
                    : "opacity-100 translate-x-0"
                } 
                group-hover:opacity-0 group-hover:translate-x-4
              `}
            >
              <p className="text-[60px] lg:text-[80px] font-[600] text-primary">
                {String(index + 1).padStart(2, "0")}
              </p>
            </div>

            <div
              className={`
                absolute top-0 left-0 w-full h-full flex flex-col items-start py-[32px] px-[24px]
                transition-all duration-700 text-white
                ${
                  isActive
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 translate-x-0 lg:translate-x-10"
                }
                group-hover:opacity-100 group-hover:translate-x-0
              `}
            >
              {card?.few_seats_left && (
                <div className="absolute -top-[19px] right-4 bg-[#FFC027] text-black text-[12px] font-[600] px-[8px] py-[12px] rounded-[20px] shadow-md z-10">
                  Few Seats Left
                </div>
              )}

              <div
                className={`
                  flex flex-col gap-[32px] overflow-hidden
                  transition-all duration-500 delay-300 group-hover:opacity-100 group-hover:translate-x-0 w-full
                  ${
                    isActive
                      ? "opacity-100 translate-x-0"
                      : "opacity-0 translate-x-0 lg:translate-x-4"
                  }
                `}
              >
                <div className="flex flex-col gap-[16px]">
                  <div className="flex flex-col gap-[16px] lg:gap-[12px]">
                    <h3 className="text-[24px] font-[600] leading-[110%] transition-all duration-700 delay-500">
                      {card?.title}
                    </h3>
                    <div className="flex gap-[12px] items-center">
                      <p className="line-through text-[#A0A0A0] font-[600]">
                        ₹ {Number(card?.price).toLocaleString("en-IN")}
                      </p>
                      {card?.is_discounted && (
                        <p className="text-[21px] text-[#FF9A27] font-[600]">
                          ₹{" "}
                          {Number(card?.discount_price).toLocaleString("en-IN")}
                        </p>
                      )}
                    </div>
                  </div>

                  {card?.short_description && (
                    <ReactMarkdown
                      rehypePlugins={[rehypeSanitize]}
                    >
                      {card.short_description}
                    </ReactMarkdown>
                  )}
                </div>

                <div className="flex flex-col gap-[12px]">
                  <div className="flex gap-[12px] items-center">
                    <IdentificationBadge size={24} />
                    <p className="font-[400] text-[21px] text-[#E4E4E4]">
                      Upcoming Batch:{" "}
                      <span className="text-[21px] font-[600]">
                        {new Date(card?.starting_date).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                          }
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="flex gap-[12px] items-center">
                    <Clock size={24} />
                    <p className="font-[400] text-[16px] text-[#E4E4E4]">
                      Schedule:{" "}
                      <span>
                        {card?.batch_time ? card?.batch_time : "Coming Soon!"}
                      </span>
                    </p>
                  </div>
                  <div className="flex gap-[12px] items-center">
                    <Calendar size={24} />
                    <p className="font-[400] text-[16px] text-[#E4E4E4]">
                      {card?.batch_type} Batch{" "}
                      {card?.batch_days?.length > 0 && (
                        <span>({card.batch_days.join(" & ")})</span>
                      )}
                    </p>
                  </div>
                  <Link
                    href={getFullSignupPath(card)}
                    className="px-[16px] py-[8px] bg-white text-[#0D6FEA] font-[400] rounded hover:bg-gray-200 transition-all duration-300 delay-700 uppercase flex gap-[8px] items-center justify-center cursor-pointer"
                  >
                    Buy Full Course <ArrowRight size={24} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BatchCards;
